import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim is grounded in EAKC-MVP:
//   src/lib/skills/sources/background-review.ts  (per-turn proposer, gemini-2.5-flash)
//   src/app/api/v1/chat/completions/route.ts:9143 (void backgroundReviewTurn — fire-and-forget)
//   src/lib/skills/applier/auto-apply.ts + handlers/persona-rule.ts (auto-apply + marker undo)
//   src/lib/skills/types.ts (12 SKILL_KINDS, 2 GATED) · migrations 204/205.
// HONESTY: auto-PROMOTION / trust-gated autonomy is QUEUED — capability gate defaults OFF.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.4, caption: "After a normal chat, my agent quietly edits its own persona — no human in the loop." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 6, caption: "You correct an agent — 'stop doing X', 'always cite the file'. Useful. Then the session ends." },
  { scene: "problem", fromSec: 6.6, holdSec: 6.5, caption: "Next chat: a blank slate. The correction evaporated. You teach the same lesson forever." },
];

export const INTUITION: ScriptLine[] = [
  { scene: "intuition", fromSec: 0.4, holdSec: 5.5, caption: "So: after each turn, a cheap reviewer asks one question — was a durable rule just stated?" },
  { scene: "intuition", fromSec: 6.2, holdSec: 5, caption: "If yes, it writes that rule down as a skill. If not, it stays quiet." },
];

export const TRIGGER: ScriptLine[] = [
  { scene: "trigger", fromSec: 0.4, holdSec: 6, caption: "It runs after EVERY assistant turn — fire-and-forget, so chat latency never moves." },
  { scene: "trigger", fromSec: 7, holdSec: 6.5, caption: "A Gemini-Flash pass reads the last six turns and proposes zero to three persona-rules." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.5, holdSec: 6.5, caption: "background-review.ts. The prompt is strict: no rule unless a specific user sentence motivates it." },
  { scene: "code", fromSec: 7.5, holdSec: 7, caption: "False positives pollute the persona — so empty array is the default, and echoed examples are dropped." },
  { scene: "code", fromSec: 15, holdSec: 7.5, caption: "A thrash guard + 7-day dedup stop it from re-proposing a rule you already rejected." },
];

export const APPLY: ScriptLine[] = [
  { scene: "apply", fromSec: 0.4, holdSec: 6, caption: "Non-gated skills auto-apply immediately — the body is wrapped in markers and appended to the persona." },
  { scene: "apply", fromSec: 6.6, holdSec: 6.5, caption: "That's the safety net: Undo is deterministic. Strip the marked block, the persona is byte-for-byte restored." },
];

export const HONESTY: ScriptLine[] = [
  { scene: "honesty", fromSec: 0.4, holdSec: 6, caption: "Twelve skill kinds exist. Ten auto-apply with Undo. Two — recipients, tool grants — always need approval." },
  { scene: "honesty", fromSec: 6.6, holdSec: 6.5, caption: "Be honest: this is auto-apply-with-Undo, not trust-gated autonomy. Auto-PROMOTION is still queued." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "The agent that learns from a chat — and that you can cleanly undo — beats the one that forgets." },
  { scene: "outro", fromSec: 6, holdSec: 4, caption: "Next: I shipped twelve skill types — and only one of them actually ran." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
